module.exports = __webpack_public_path__ + "static/img/wdhj1-2.0c5f562.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdhj1-2.png
// module id = 864
// module chunks = 0